import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

// Whether this page has an in-app page behind it to go back to. A page opened
// straight from a link in a new tab (email, Slack, a pasted URL) is the first
// entry in its tab: React Router marks it 'default', and history.back() there
// does nothing at all.
export const canGoBackInApp = (location) => Boolean(location?.key) && location.key !== 'default';

/**
 * A Back / Close handler that goes back when there is somewhere in the app to
 * go back to, and otherwise to `fallback` (replacing this entry), so the
 * button is never a dead end.
 */
export function useGoBackOr(fallback = '/') {
  const navigate = useNavigate();
  const location = useLocation();
  return useCallback(() => {
    if (canGoBackInApp(location)) navigate(-1);
    else navigate(fallback, { replace: true });
  }, [navigate, location, fallback]);
}

export default useGoBackOr;
